
import initVue from '../util/plan';

export default {
  init() {
    // JavaScript to be fired on the home page

    initVue();
    //initVue2();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templatePlan.js